<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold;margin-left: 20px;">用户信息</span>
          <Input
              v-model="filterData.keyword"
              maxlength="6"
              placeholder="请输入昵称关键字"
              clearable
              style="min-width: 80px; width:150px; margin-right: 10px;margin-left: 30px;"/>
          <Button @click="getData(1)">搜索</Button>
          <span v-show="listCount>=0"style="font-weight: bold;margin-left: 10px;">共{{listCount}}条</span>
        </div>
        <div>
        </div>
      </div>
      <div style="width: 100%; display: flex;">
          <div class="report-content">
              <Table :columns="columns" :data="changeDataList" @on-selection-change="selected">
                <template slot-scope="{ row, index }" slot="id">
                    <div class="avatar" style="margin-top: 6px;">
                        <Poptip trigger="hover" :transfer="true" title="图片详情">
                              <div class="info-pop" slot="content">
                                  <img :src="row.current_avatar" class="img-avatar-preview">
                              </div>
                              <img :src="row.current_avatar" class="img-avatar">
                        </Poptip>
                    </div>
                   <!-- <div style="margin-left: -70px; margin-top: 63px;float: left;">
                        状态:<span :style="row.app_status_color">{{row.app_status}}</span>
                    </div> -->
                  <table style="margin-bottom: 5px;">
                      <tr>
                          <td class="report-table-td-title">身份ID：</td>
                          <td class="report-table-td-content">{{ row.invite_code }}</td>
                          <td>
                             <Button 
                              class="report-button-other" 
                              type="warning"
                              size="small"
                              v-show = "row.id>0"
                              @click="toResetUseInfo('avatar',row,row.avatar)">重置头像</Button>
                          </td>
                      </tr>
                      <tr>
                          <td class="report-table-td-title">昵称：</td>
                          <td class="report-table-td-content">{{ row.nickname }} </td>
                          <td>
                             <Button
                              class="report-button" 
                              type="warning"
                              size="small"
                              v-show = "row.id>0"
                              @click="toResetUseInfo('nickname',row,row.nickname)">重置</Button>
                          </td>
                      </tr>
                      <tr>
                          <td class="report-table-td-title">个性签名：</td>
                          <td class="report-table-td-content">{{ row.signature ? row.signature : '暂无' }} </td>
                          <td>
                             <Button
                              class="report-button-other" 
                              type="warning"
                              size="small"
                              v-show = "row.id>0"
                              @click="toResetUseInfo('signature',row ,row.signature)">重置</Button>
                          </td>
                      </tr>
                     <tr>
                          <td class="report-table-td-title">账号状态：</td>
                          <td class="report-table-td-content"><span :style="row.app_status_color">{{row.app_status}}</span> </td>
                          <td></td>
                      </tr>
                  </table>
                </template>
              </Table>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "../../http/api";
import commonApi from "../../utils/commonapi";

export default {
  name: "ReportCheck",
  components: {},
  watch: {
  },
  data() {
    return {
      filterData: {
        keyword:null,
      },
      defaultUser:{'avatar':"https://image.co-study.com.cn/app/image/avatar/webco.png",'nickname':'Co用户昵称','invite_code':'0000'},
      user:{'avatar':"https://image.co-study.com.cn/app/image/avatar/webco.png",'nickname':'Co用户昵称','invite_code':'0000'},
      dataList: [],
      listCount:-1,
      columns: [
        {
          title: '搜索结果',
          slot: 'id',
          align: 'center'
        },
      ],
      isOnRequest:false,
    }
  },
  created() {
  },
  methods: {
    getData(is_input) {
      if(this.filterData.keyword == undefined || this.filterData.keyword == ""){
          this.$Message.error('请输入关键字'); 
          return 
      }
      let params = {
        keyword: this.filterData.keyword
      };
      if(is_input == 1){
          // 记录-即刻-查询用户信息
          commonApi.recordFromOperationToolJKUserInfoSearch(0, this.filterData.keyword)
      }
      apis.jk_user_text_info(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.dataList =data.users;
          if(this.dataList !== undefined ){
             this.listCount = this.dataList.length
          }
        }else{
          this.$Message.error(msg); 
          this.dataList = null
          this.listCount = -1
        }
      }).catch(err => {
        this.$Message.error('接口异常,请联系管理员'); 
        this.dataList = null
        this.listCount = -1
      })
    },
    toResetUseInfo(key,row,content) {
       
        if(this.isOnRequest == true){
             this.$Message.error('重置中，请稍后操作！'); 
            return;
        }
         this.isOnRequest = true
        this.user = row
      if(this.user == undefined || this.user.id == undefined || this.user.id<=0){
          this.$Message.error('用户信息异常'); 
          this.isOnRequest = false;
          return 
      }
      let params = {
        user_id: this.user.id,
        reset:key
      };
      apis.jk_user_text_reset(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
            this.$Message.success('用户(邀请码：'+ this.user.invite_code +')重置成功！'); 
            // 记录-即刻-重置用户信息
            commonApi.recordFromOperationToolJKUserInfoReset(0, key, this.user.id,content)
            
            setTimeout(() => {
                var users =[];
               this.dataList.forEach(item => {
                    if(item.id === data.user.id){
                        item = data.user
                    }
                    users.push(item)
               })
               this.dataList = users
               this.user = null
               this.isOnRequest = false;
            }, 200);
        }else{
          this.$Message.error(msg); 
          this.isOnRequest = false;
        }
      }).catch(err => {
         this.$Message.error('接口异常,请联系管理员');
         this.isOnRequest = false;
      })
    },
    selected(selecttion) {
      console.log(selecttion.id)
    },
  },
  computed: {
      changeDataList() {
          return this.dataList.map(item => {
              var avatar = item.avatar
              if(avatar == undefined || avatar == ""){
                  item['current_avatar'] = "https://image.co-study.com.cn/app/image/avatar/webco.png"
              }else if(avatar.startsWith("http")){
                  item['current_avatar'] = avatar
              }else{
                  item['current_avatar'] = "https://image.co-study.com.cn/app/image/avatar/"+ avatar
              }
              // 0为正常，-1为封禁, -2是注销
              var status = '正常'
              var color = {color:"#000000"}
              switch(item.active){
                  case -1:
                    status = '封禁'
                    color = {color:'red'}
                    break
                  case -2:
                    status = '注销'
                    color = {color:'gray'}
                    break
                  case 0:
                    status = '正常'
                    color = {color:'green'}
                    break
                  default:
                    status = '未知'
                    color = {color:"#000000"}
                    break
              }
              item['app_status'] = status
              item['app_status_color'] = color
            return item
          })
      }
  },
  filters: {
  }
}
</script>

<style scoped>
.report-check {
  margin: 10px;
}

.clickable-span {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}

.avatar{
    float: left;
    width: 50px;
    margin-top: 20px;
    margin-right: 15px;
}
.img-avatar{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid lightgray;
}
.img-avatar-preview{
    width: 400px;
    height: 400px;
}
.report-content{
    float: left;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
}
.report-table-td-title{
    width: 95px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
     vertical-align: top;
}
.report-table-td-content{
    width: 360px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
}
table, th, td {
  border: 2px solid transparent;
  border-collapse: collapse;
}
table,  td {
    height: auto;
}
.report-button{
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
}
.report-button-other{
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
    background-color: #fff;
    /* border-color: #f90; */
    border: 0.5px solid #ff9900;
    color: #f90;
}
</style>
